import fetch from "isomorphic-fetch";
import previewTripData from "../data/PreviewTrip";

const { dictionary, option, project } = previewTripData

const fetchDictionaryApi = () => {
  return Promise.resolve(dictionary);
};

const fetchOptionApi = () => {
  return Promise.resolve(option);
};
const fetchProjectApi = () => {
  return Promise.resolve(project);
};

const fetchCountriesApi = () => {
  return fetch('https://restcountries.eu/rest/v2/all?fields=name;currencies')
  .then(response => response.json())
  .then(response => {
    // console.log('fetchCountries', response)
    return response
  })
}

const fetchCurrencyApi = () => {
  return {}
  // return fetch('https://us-central1-forviz-2017.cloudfunctions.net/partners/exchange-currency-rates/latest')
  // .then(response => response.json())
  // .then(response => {
  //   return response.result
  // })
}

export {
  fetchDictionaryApi,
  fetchOptionApi,
  fetchProjectApi,
  fetchCountriesApi,
  fetchCurrencyApi
};



// WEBPACK FOOTER //
// ./src/services/preview-trip.js